import { TaskCategoryGet, Ulid } from "@kase/my-marathon-communication";
import { ApiSliceParams } from "../interfaces";
import { createListController } from "../utils";
import {
    CreateTaskCategoryRequest,
    TaskCategory,
    UpdateTaskCategoryRequest,
} from "./interfaces";

export const makeCategory = ({ connection, company }: ApiSliceParams) => {
    const {
        items: categories,
        listen,
        allLoading: loading,
    } = createListController<TaskCategoryGet, TaskCategory, string | void>({
        connection,
        list: (con, cmp) =>
            con.task.category.items({ company: cmp ?? company.value }),
        getKey: (cmp) => cmp ?? company.value,
        name: "task-category",
    });

    const create = (request: CreateTaskCategoryRequest) => {
        return connection.value.task.category.create({
            company: request.company ?? company.value,
            name: request.name,
            description: request.description,
        });
    };

    const update = (request: UpdateTaskCategoryRequest) => {
        const existing = categories
            .peek()
            .find((c) => c._id.equals(request.id));

        if (!existing) {
            throw new Error("Task category not found");
        }

        return connection.value.task.category.update({
            ...request,
            etag: existing.etag,
        });
    };

    const remove = (id: Readonly<Ulid>) => {
        const existing = categories.peek().find((c) => c._id.equals(id));

        if (!existing) {
            throw new Error("Task category not found");
        }

        return connection.value.task.category.delete({
            id,
            etag: existing.etag,
        });
    };

    return { categories, loading, listen, create, update, remove };
};
